/**
 * Checks if response status is 2.x.x, else return error
 *
 * @param {XMLHTTPResponse} response - http response from fetch
 * @returns {Promise} resolved or rejected response
 */
const checkStatus = async (response) => {
  if (response.ok) {
    return Promise.resolve(response);
  }

  // Request failed, attempt to parse server defined error message
  try {
    let error = await response.json();
    // Parse successful
    return Promise.reject(error.message ? new Error(error.message) : error);
  } catch (error) {
    // Parse not successful
    return Promise.reject(new Error(`${response.status}: ${response.statusText}`));
  }
};

export { checkStatus };
